import type { OtpRole } from 'types/commons/model'

export const SCAN_PRODUCT_ERRORS = {
  upcNotFound: 'not-existing-upc'
}

export const MEASURE_LABELS_PLURAL: Record<string, string> = {
  kg: 'gramos',
  box: 'cajas',
  pcs: 'unidades'
}

export const ZOD_ERROR =
  'Error de tipos: Los datos recibidos no tienen el formato esperado'

export const MISSING_LABELS_PLURAL: Record<string, string> = {
  missing: 'faltantes',
  waste: 'merma'
}

export const PUSH_MESSAGE_ID = 'SW_NEW_PALLET'

export const OTP_ROLE_PREFIX = 'OTP_TYPE'

export const OTP_ROLES: Record<string, OtpRole> = {
  OTP_TYPE_ARMADO: {
    id: 'OTP_TYPE_ARMADO',
    label: 'Armado',
    iconName: 'ic_shapes'
  }
}

export const PROGRESS_STATUS = ['inProgress']
